'use client'
import { useComponentTranslation } from '@core/i18n'
import { Icon, Tag } from '@core/ui-elements'
import { _IAssortmentType, IDeliveryNormalized } from '@data/types'
import { IHandleDeliveryCardClick } from '@modules/delivery/deliveries.types'
import { deliveryStatusClassification } from '@utils/arrays'
import { CardColors } from '@utils/styles'
import { FC, useState } from 'react'
import { MdOutlineAddLocationAlt } from 'react-icons/md'

import { Card, cardColorSchema } from '../card'
import { DeliveryCardContent } from '../delivery-card-content'

export interface IDashboardCard {
  delivery: IDeliveryNormalized
  secondsCountdown?: number
  columnType: deliveryStatusClassification
  showRider?: boolean
  showShopper?: boolean
  warningThresholdPercent?: number
  criticalThresholdPercent?: number
  handleDeliveryCardClick?: ({ delivery }: IHandleDeliveryCardClick) => void
  hideCustomerOrderCount: boolean
}

export const DashboardCard: FC<IDashboardCard> = ({
  delivery,
  secondsCountdown,
  columnType,
  handleDeliveryCardClick,
  showRider = true,
  showShopper = true,
  warningThresholdPercent,
  criticalThresholdPercent,
  hideCustomerOrderCount,
}) => {
  const t = useComponentTranslation('DashboardCard')
  const [cardColor, setCardColor] = useState<CardColors>(CardColors.grayWhite)

  const isStacking = !!delivery.relatedDeliveries.length
  const isSuperDaki = delivery.assortmentType === _IAssortmentType.plus

  const color = isSuperDaki ? CardColors.blue : cardColor

  return (
    <Card
      color={color}
      onClick={
        handleDeliveryCardClick
          ? () =>
              handleDeliveryCardClick({
                delivery,
              })
          : undefined
      }
    >
      <DeliveryCardContent
        columnType={columnType}
        criticalThresholdPercent={criticalThresholdPercent}
        delivery={delivery}
        hideCustomerOrderCount={hideCustomerOrderCount}
        secondsCountdown={secondsCountdown}
        setStructureColor={setCardColor}
        showRider={showRider}
        showShopper={showShopper}
        warningThresholdPercent={warningThresholdPercent}
      />
      {isStacking ? (
        <Tag
          alignItems="center"
          bgColor={cardColorSchema[color]['body']['full']['borderColor']}
          color="white"
          lineHeight="1.5rem"
          size="md"
          width="100%"
        >
          <Icon as={MdOutlineAddLocationAlt} fontSize={'1.25rem'} />{' '}
          {t('Stacking delivery')}
        </Tag>
      ) : null}
    </Card>
  )
}
